/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { RfpDraftsControllerRfpQueryResponse, RfpDraftsControllerRfpPathParams, RfpDraftsControllerRfp400, RfpDraftsControllerRfp401, RfpDraftsControllerRfp403, RfpDraftsControllerRfp404 } from "../../models/rfpDraftsController/RfpDraftsControllerRfp";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { rfpDraftsControllerRfp } from "../../clients/rfp-draftsService/rfpDraftsControllerRfp";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const rfpDraftsControllerRfpQueryKey = (id: RfpDraftsControllerRfpPathParams["id"]) => [{
  url: '/api/v1/document-drafts/rfp/:id',
  params: {
    id: id
  }
}] as const;
export type RfpDraftsControllerRfpQueryKey = ReturnType<typeof rfpDraftsControllerRfpQueryKey>;
export function rfpDraftsControllerRfpQueryOptions(id: RfpDraftsControllerRfpPathParams["id"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = rfpDraftsControllerRfpQueryKey(id);
  return queryOptions<RfpDraftsControllerRfpQueryResponse, ResponseErrorConfig<RfpDraftsControllerRfp400 | RfpDraftsControllerRfp401 | RfpDraftsControllerRfp403 | RfpDraftsControllerRfp404>, RfpDraftsControllerRfpQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return rfpDraftsControllerRfp(id, config);
    }
  });
}

/**
 * {@link /api/v1/document-drafts/rfp/:id}
 */
export function useRfpDraftsControllerRfp<TData = RfpDraftsControllerRfpQueryResponse, TQueryData = RfpDraftsControllerRfpQueryResponse, TQueryKey extends QueryKey = RfpDraftsControllerRfpQueryKey>(id: RfpDraftsControllerRfpPathParams["id"], options: {
  query?: Partial<QueryObserverOptions<RfpDraftsControllerRfpQueryResponse, ResponseErrorConfig<RfpDraftsControllerRfp400 | RfpDraftsControllerRfp401 | RfpDraftsControllerRfp403 | RfpDraftsControllerRfp404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? rfpDraftsControllerRfpQueryKey(id);
  const query = useQuery({
    ...rfpDraftsControllerRfpQueryOptions(id, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<RfpDraftsControllerRfp400 | RfpDraftsControllerRfp401 | RfpDraftsControllerRfp403 | RfpDraftsControllerRfp404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}